module.exports = __webpack_public_path__ + "img/inbox_w.69570db7.svg";